import { BookModel } from "./book-model"

export class VersesModel
{
  id: number=0;
  book: string='';
  verse: string='';
  unformatted: string='';
  unformattedSearch: string='';
  chapitreReal: string='';
  versetReal: string='';
  bookData: BookModel= new BookModel();
}

export enum VersesTextField
{
  title= 'Verses',
  id= 'Id',
  book= 'Book',
  verse= 'Verse',
  unformatted= 'Unformatted',
  unformattedSearch= 'Unformatted Search',
  chapitreReal= 'Chapitre Real',
  versetReal='Verset Real',
}
